module.exports = __webpack_public_path__ + "img/sj_pre@2x.30d82b7f.png";